// The kubb client throws `Error` objects augmented with the HTTP `status`.
export const getApiErrorStatus = (error: unknown): number | undefined =>
  typeof error === 'object' && error != null ? (error as { status?: number }).status : undefined;

// API errors surface the useful text in `body.error` (or `body`/`error` as a raw string)
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  if (typeof error === 'object' && error != null) {
    const typedError = error as { body?: unknown; error?: unknown; message?: unknown };

    if (typeof typedError.body === 'object' && typedError.body != null) {
      const bodyError = (typedError.body as { error?: unknown }).error;
      if (typeof bodyError === 'string' && bodyError) {
        return bodyError;
      }
    }
    if (typeof typedError.body === 'string' && typedError.body) {
      return typedError.body;
    }
    if (typeof typedError.error === 'string' && typedError.error) {
      return typedError.error;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  if (typeof error === 'object' && error != null) {
    const typedError = error as { message?: unknown };
    if (typeof typedError.message === 'string' && typedError.message) {
      return typedError.message;
    }
  }

  return fallback;
};
